import React from 'react';
import './Gallery.css';

const Gallery = () => {
  const images = [
    // Existing slideshow images
    { 
      id: 1, 
      src: '/images/aicisSummit_activities_01.jpg', 
      title: 'Summit Opening Ceremony',
      description: 'The grand opening of AICIS Summit with distinguished guests and delegates from across the globe.'
    },
    { 
      id: 2, 
      src: '/images/aicisSummit_activities_02.jpg', 
      title: 'Investment Forum',
      description: 'High-level investment forum connecting global investors with African business opportunities.'
    },
    { 
      id: 3, 
      src: '/images/aicisSummit_activities_03.jpg', 
      title: 'Trade Mission',
      description: 'Delegates on a trade mission exploring business opportunities across the continent.'
    },
    { 
      id: 4, 
      src: '/images/aicisSummit_activities_04.png', 
      title: 'Board Meeting',
      description: 'Strategic board meeting with key stakeholders and decision-makers.'
    },
    { 
      id: 5, 
      src: '/images/aicisSummit_activities_05.jpg', 
      title: 'Networking Event',
      description: 'Networking session bringing together business leaders and industry experts.'
    },
    { 
      id: 6, 
      src: '/images/aicisSummit_activities_06.png', 
      title: 'Exhibition',
      description: 'Exhibition showcasing innovative products and solutions from across Africa.'
    },
    { 
      id: 7, 
      src: '/images/aicisSummit_activities_07.jpg', 
      title: 'Conference Session',
      description: 'Engaging conference sessions on climate change and infrastructure development.'
    },
    { 
      id: 8, 
      src: '/images/aicisSummit_activities_08.jpg', 
      title: 'Award Ceremony',
      description: 'Celebrating excellence with the AICIS awards ceremony recognizing outstanding contributions.'
    },
    // New AICIS 2025 images
    { 
      id: 10, 
      src: '/images/2025-1.jpeg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 11, 
      src: '/images/2025-2.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 12, 
      src: '/images/2025-3.jpeg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 13, 
      src: '/images/2025-4.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 14, 
      src: '/images/2025-5.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 15, 
      src: '/images/2025-6.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 16, 
      src: '/images/2025-7.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 17, 
      src: '/images/2025-8.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    },
    { 
      id: 18, 
      src: '/images/2025-9.jpg', 
      title: 'AICIS 2025',
      description: 'AICIS 2025 Summit - Connecting Africa to the World.'
    }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Gallery</h1>
        <p>Photos from our events and activities</p>
      </section>

      <section className="gallery-page-section">
        <div className="container">
          <div className="gallery-page-grid">
            {images.map((image) => (
              <div className="gallery-page-item" key={image.id}>
                <div 
                  className="gallery-page-image" 
                  style={{backgroundImage: `url(${image.src})`, backgroundPosition: '50% 20%'}}
                ></div>
                <div className="gallery-page-caption">
                  <h3>{image.title}</h3>
                  <p>{image.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;